import _ from 'lodash'
import { getMultipleRefCompsIdFromInflatedId, getUniqueId } from '@wix/thunderbolt-commons'
import type { BaseDataItem, SlotsDataItem } from '@wix/thunderbolt-becky-types'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import type { DataItemWithOverridesRefs } from '../../types'
import { getOverrideItem } from '../../dataConsumption'
import { getRefCompIds } from '../../../byRefUtils'

const getResolvedOverrideItemNestingLevel = (items: Readonly<Array<BaseDataItem | undefined>>) =>
	items.findIndex(Boolean)!

export const Slots = createConsumptionDataNode<SlotsDataItem, null, DataItemWithOverridesRefs>({
	toViewItem: ({ id, value: { dataItemWithOverrides } }) => {
		const dataItem = getOverrideItem(dataItemWithOverrides)
		if (!dataItem) {
			return
		}

		const overrideIndex = getResolvedOverrideItemNestingLevel(dataItemWithOverrides)
		// if the override is in the consumer level, we don't need to inflate the slots ids
		if (overrideIndex === 0) {
			return dataItem
		}

		const consumerContext = getMultipleRefCompsIdFromInflatedId(id)
		const ancestorsRefIds = getRefCompIds(consumerContext)
		const context = ancestorsRefIds[overrideIndex - 1]

		const slots = _.get(dataItem, 'slots')
		const inflatedSlots = _.mapValues(slots, (slotId) => getUniqueId(context, slotId))

		return {
			...dataItem,
			slots: inflatedSlots,
			id,
		}
	},
})
